var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ width: '24', height: '24', viewBox: '0 0 24 24', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement('path', { d: 'M21.5 5.1l-2.8-2.8c-.4-.4-1-.4-1.4 0l-8.5 8.5c-.2.2-.3.4-.3.6L8 14.6v.3c.1.5.6.9 1.2.9l3.3-.4c.2 0 .4-.1.6-.3l8.4-8.5c.4-.4.4-1.1 0-1.5zm-9.7 8.3L10.4 12 18 4.5l1.4 1.4-7.6 7.5z', role: 'presentation' }),
    React.createElement('path', { d: 'M5 19V5h3a1 1 0 100-2H4a1 1 0 00-1 1v16a1 1 0 001 1h16a1 1 0 001-1v-8a1 1 0 00-2 0v7H5z', role: 'presentation' })
  );
}

module.exports = function paperEdit(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};